<template>
  <div :class="['top', { 'reduction': reduction }]">
    <div class="top-background-wrapper" :style="`background-image: url(${require('@/assets/images/top_background.jpg')})`">
      <div class="room-name-feedback-container">
        <div v-if="validation.roomName.used" class="room-name-used-feedback">
          {{ $t('common.feedbacks.roomName.used') }}
        </div>
        <div v-if="validation.roomName.invalidRule" class="room-name-invalid-feedback">
          {{ $t('common.feedbacks.roomName.invalidRule') }}
        </div>
        <div v-if="validation.roomName.invalidRoomName" class="room-name-invalid-feedback">
          {{ $t('common.feedbacks.roomName.invalidRoomName') }}
        </div>
      </div>
      <div class="room-name-container">
        <div class="d-none d-md-block">
          <label class="room-name-label">{{ appUrl }}</label>
        </div>
        <div>
          <input v-model="roomName" type="text" class="room-name-input" placeholder="room name"/>
        </div>
        <div>
          <stella-button
            :disabled="validation.roomName.invalidRule || validation.roomName.invalidRoomName || roomName == ''"
            @click.native="onClickEnterRoom"
          >
            {{ $t('pages.top.enterRoom') }}
          </stella-button>
        </div>
      </div>
    </div>
    <!-- <div class="top-content">
      <div class="top-content-example">
        【トップコンテンツ領域】
      </div>
    </div> -->
  </div>
</template>

<script>
import PeerClient from 'peerjs'
import PEER_CONFIG from '@/lib/peerConfig'
import { INVALID_ROOM_NAMES } from '@/lib/constants'

export default {
  name: 'Top',
  computed: {
    appUrl: () => process.env.VUE_APP_URL,
    roomName: {
      get () {
        return this.innerRoomName
      },
      set (value) {
        this.validation.roomName.invalidRule = value && value.match(/^[a-zA-Z0-9-_]*$/) === null
        this.validation.roomName.invalidRoomName = INVALID_ROOM_NAMES.includes(value)

        if (!value || this.validation.roomName.invalidRule || this.validation.roomName.invalidRoomName) {
          this.validation.roomName.used = false
        } else {
          this.peerClient.knock(value)
        }
        this.innerRoomName = value
      }
    },
    reduction: function() {
      return this.scrollY > 0
    }
  },
  data() {
    return {
      peerClient: null,
      scrollY: 0,
      innerRoomName: '',
      validation: {
        roomName: {
          invalidRule: false,
          invalidRoomName: false,
          used: false
        }
      },
      closed: false
    }
  },
  async created () {
    const peerClient = new PeerClient({
      secure: PEER_CONFIG.secure,
      host: PEER_CONFIG.host,
      port: PEER_CONFIG.port
    })

    peerClient.on('connect', () => {
      peerClient.enterRoom()
    })

    peerClient.on('disconnected', () => {
      if (!this.closed) peerClient.reconnect()
    })

    peerClient.on('knock-reply', (_, payload) => {
      const { roomName, isExists } = payload
      this.validation.roomName.used = this.innerRoomName === roomName && isExists
    })

    this.peerClient = peerClient
  },
  mounted() {
    window.addEventListener('scroll', this.calculateScrollY)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.calculateScrollY)
    this.close()
  },
  methods: {
    calculateScrollY: function() {
      this.scrollY = window.scrollY
    },
    onClickEnterRoom: function() {
      this.$router.push({ name: 'room', params: { roomName: this.roomName } })
    },
    close: function() {
      if (this.closed) return

      this.closed = true
      if (this.peerClient) this.peerClient.destroy()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

.top {
  width: 100%;

  .top-background-wrapper {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    transition: height 0.3s ease-in-out, box-shadow 0.5s ease-in-out;
    background-size: cover;
    background-position: center;
    box-shadow: inset 0 0 0 100vw rgba(0, 0, 0, 0.2), 0px 0px 4px #00000026;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @include mq(md) {
      position: fixed;
    }
  }

  .top-content {
    position: relative;
    z-index: 1000;
    margin-top: 100vh;
    margin-bottom: 60px;
    transition: margin-top 0.3s ease-in-out;
    padding: 20px 0;
    text-align: center;

    @include mq(md) {
      z-index: 0;
    }

    @include mq(lg) {
      padding: 40px 0;
    }

    .top-content-example {
      height: 100vh;
      border: 2px solid black;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 600;
    }
  }

  &.reduction .top-background-wrapper {
    @include mq(md) {
      padding: 40px 0;
      height: 100px;
      box-shadow: inset 0 0 0 100vw rgba(0, 0, 0, 0.5), 0px 0px 4px #00000026;
    }

    .room-name-container {
      @include mq(md) {
        font-size: 0.8rem;
      }

      @include mq(lg) {
        font-size: 1rem;
      }
    }

    .room-name-feedback-container {
      @include mq(lg) {
        font-size: 0.6rem;
      }
    }
  }

  &.reduction .top-content {
    @include mq(md) {
      margin-top: 50vh;
    }
  }
}

.room-name-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  transition: font-size 0.5s ease-in-out;
  font-size: 16px;
  transform: scale(0.999);

  @include mq(md) {
    font-size: 1rem;
  }

  @include mq(lg) {
    font-size: 1.2rem;
  }

  .room-name-label {
    color: white;
    font-weight: 600;
    margin-right: 10px;
    margin-bottom: 0;
  }

  .room-name-input {
    color: white;
    background-color: transparent;
    font-weight: 600;
    border: 1px solid white;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    margin-right: 10px;
    outline: none;
  }
}

.room-name-feedback-container {
  margin-bottom: 5px;
  font-size: 0.6rem;
  transition: font-size 0.5s ease-in-out;

  @include mq(lg) {
    font-size: 0.8rem;
  }

  .room-name-invalid-feedback {
    color: white;
    text-align: center;
  }

  .room-name-used-feedback {
    color: white;
    font-weight: 600;
    text-align: center;
  }
}
</style>
